package core.enums

enum class ELinks(val mUrl: String) {
    // ----------------------------------------------------------------------------
    // Enumeration List
    // ----------------------------------------------------------------------------

    GOOGLE_PLAY_STORE("https://play.google.com/store/apps/details?id=de.emgress.scj&hl=de"),
    APPLE_APP_STORE("https://apps.apple.com/de/app/baskets-jena/id875269523"),
    SPORTDEUTSCHLAND_TV("https://sportdeutschland.tv/sc-jena"),
    LANDINGPAGE_APPS("/apps"),

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------
}